import { Component, OnInit, ChangeDetectionStrategy, HostListener, HostBinding, Inject, OnDestroy } from '@angular/core';
import { ScrollToTop } from '../../../utils/functions';
import { Router } from '@angular/router';
import { AccountService } from '../../../services/account.service';
import { DOCUMENT } from '@angular/common';
import { IdleLogoutService } from '../../../services/idle-logout.service';

@Component({
  selector: 'app-research-portal-main',
  templateUrl: './research-portal-main.component.html',
  styleUrls: ['./research-portal-main.component.scss'],
})
export class ResearchPortalMainComponent implements OnInit, OnDestroy {
  @HostBinding('class.portal') portalClass = true;
  toggle = false;
  showScroll = false;
  constructor(
    private router: Router,
    private accountService: AccountService,
    @Inject(DOCUMENT) private document: Document,
    private idleLogoutService: IdleLogoutService
  ) {}

  @HostListener('window:scroll', [])
  onWindowScroll() {
    let $window = $(window);
    if ($window.scrollTop() > $window.height() / 2) {
      this.showScroll = true;
    } else {
      this.showScroll = false;
    }
  }

  async ngOnInit() {
    this.document.body.classList.add('sidebar-collapse-in');
    this.accountService.emit(true);

    // Initialize idle logout for research portal
    this.idleLogoutService.initializeIdleLogout('research-portal');

    // this.toggleMenu(true)
    // await this.router.navigate(['/research-portal/sectors']);
  }

  toggleMenu(e) {
    console.log('mmmm');
    this.toggle = e;
  }

  onMobileMenuToggle(isOpen: boolean) {
    // This will be handled by the side menu component through the body class
  }

  closeMobileMenu() {
    if (this.document.body.classList.contains('mobile-menu-open')) {
      this.document.body.classList.remove('mobile-menu-open');
      this.document.body.style.overflow = '';
    }
  }

  scrollUp() {
    ScrollToTop();
  }

  ngOnDestroy() {
    // Disable idle logout when component is destroyed
    this.idleLogoutService.disableIdleLogout();
  }
}
